<div class="page-container h-100  d-flex flex-column justify-content-center align-items-center">
  <p class="confirm-text">{{msg}}</p>
  <button id="Connect" routerLink="/login" mat-raised-button color="darkGreen" type="submit" >Login!</button>
</div>
